// bao migrate skip 6770c8cf
import * as $ from "jquery";
import * as ko from "knockout";
import baoRouter from "../services/bao-router";
import baoMenu from "./../services/bao-menu";
import Bao from "./../services/bao-service";
import guid from "./guid";
import TabController from "./tab-controller";
export class TabPage implements Factories.TabPage {

	public Object: any;
	public Menu: any = baoMenu;
	public SessionTabId: string;
	public AutoSelect = true;
	public MenuEvents = [];
	public DirtyFlag = ko.dirtyFlag();
	public TabAdded = ko.observable(false);
	public TabViewModel = ko.observable<any>();
	public StatusBarVisible = ko.observable(true);
	public TemplateName = ko.observable<string>();
	public Id = ko.observable(guid());
	public Version = ko.observable();
	public EnableDirtyTracking = ko.observable(true);
	public IsDirty = ko.observable(false);
	public ToolTip = ko.observable();
	public IsClosable = ko.observable(true);
	public Url = ko.observable();
	public UrlData = ko.observable<any>({});
	public IsLoading = ko.observable(false);
	public JavaScript = ko.observable();
	public ViewModel = ko.observable<any>();
	public Context = ko.observable<any>();
	public ToolbarButtons = ko.observableArray();
	public IsActiveTab = ko.observable(false);
	public Visible = ko.observable(true);
	public Loaded = ko.observable(false);
	public PreLoad = ko.observable(true);
	public IconLeft = ko.observable();
	public Icon = ko.observable();
	public LoadingAllowed = ko.observable(false);
	public InitRoute = ko.observable("");
	public ScrollPosition = ko.observable();
	public Route: any;
	public Title: KnockoutObservable<string>;
	public ObjectId: KnockoutObservable<string>;
	public TitleComputed: KnockoutComputed<string>;
	public StatusIconComputed: KnockoutComputed<boolean>;
	public SettingsIconComputed: KnockoutComputed<boolean>;
	public SettingsHasPermission: KnockoutObservable<boolean> = ko.observable(false);
	public LoadContent: KnockoutComputed<void>;
	public $TabController: TabController; // is added by tabcontroller when adding a tab to the controller
	public subscriptions: KnockoutSubscription[] = [];
	private tabViewModel = null;
	constructor(objectId?: string, title?: string) {
		if (title == null) {
			title = "loading";
		}
		this.Title = ko.observable(title);
		this.ObjectId = ko.observable(objectId);
		this.LoadContent = ko.computed(() => {
			if (this.Url() != null && this.LoadingAllowed() === true && this.PreLoad() === true && this.Loaded() == false) {
				this.IsLoading(true);
				$.when(this.loadContent(), this.loadJavaScript()).then((result, js) => {
					if (typeof result[0] === "string") {
						result[0] = { Message: result[0] };
					}
					this.ContentLoadedDefault(result, js);
				});
			}
		}, this).extend({ throttle: 1 });
		this.StatusIconComputed = ko.computed(() => {
			const context = this.Context();
			const vm: any = this.ViewModel();
			if (vm != null && vm.ShowStatusDialog != undefined && ko.isObservable(vm.ShowStatusDialog) && vm.ShowStatusDialog() == true) {
				if ((this.Context() != null || this.ToolbarButtons() != null) && this.StatusBarVisible()) {
					let statusButtonFound = false;
					if (this.Context() != null && this.Context().Container() != null && this.Context().Container().length > 0
						&& this.Context().Container()[0].Buttons != null) {
						ko.utils.arrayForEach(this.Context().Container()[0].Buttons(), (item: any) => {
							if (item.ActionKey() == "statusbutton") {
								statusButtonFound = true;
							}
						});
					} else if (this.ToolbarButtons() != null && this.ToolbarButtons().length > 0) {
						ko.utils.arrayForEach(this.ToolbarButtons(), (item: any) => {
							if (item.ActionKey() == "statusbutton") {
								statusButtonFound = true;
							}
						});
					}
					if (statusButtonFound == false) {
						const statusButton = {
							ActionKey: ko.observable("statusbutton"),
							Caption: ko.observable(""),
							ToolTip: ko.observable("Status"),
							Visible: ko.observable(true),
							Enabled: ko.observable(true),
							TargetUrl: ko.observable(""),
							MethodInfo: ko.observable("fa fa-info"),
							click: () => {
								this.OpenStatusDialog();
							},
							ButtonType: ko.observable("Button"),
							Items: ko.observable(null)
						};
						if (this.Context() != null && this.Context().Container() != null && this.Context().Container().length > 0
							&& this.Context().Container()[0].Buttons != null) {
							this.Context().Container()[0].Buttons.push(statusButton);
						} else if (this.ToolbarButtons() != null) {
							(this.ToolbarButtons().push(statusButton));
						}
					}
					return true;
				}
			}
			return false;
		});

        this.SettingsIconComputed = ko.computed(() => {
            const vm: any = this.ViewModel();
			if (vm != null && vm.SettingsUrl != undefined && ko.isObservable(vm.SettingsUrl) && vm.SettingsUrl() && ko.isObservable(vm.SettingsKeyPermission) && vm.SettingsKeyPermission()) {
				if ((this.Context() != null || this.ToolbarButtons() != null) && this.StatusBarVisible()) {
					const applicationId = ko.unwrap(vm.SettingsKeyPermissionApplicationId);
					this.SettingsHasPermission = Bao.Session.HasPermission(vm.SettingsKeyPermission(), applicationId ? applicationId : Bao.Session.Application.ApplicationId);
					if (this.SettingsHasPermission()) {
						let settingsButtonFound = false;
						if (this.Context() != null && this.Context().Container() != null && this.Context().Container().length > 0
							&& this.Context().Container()[0].Buttons != null) {
							ko.utils.arrayForEach(this.Context().Container()[0].Buttons(), (item: any) => {
								if (item.ActionKey() == "settingsbutton") {
									settingsButtonFound = true;
								}
							});
						} else if (this.ToolbarButtons() != null && this.ToolbarButtons().length > 0) {
							ko.utils.arrayForEach(this.ToolbarButtons(), (item: any) => {
								if (item.ActionKey() == "settingsbutton") {
									settingsButtonFound = true;
								}
							});
						}
						if (settingsButtonFound == false) {
							const statusButton = {
								ActionKey: ko.observable("settingsbutton"),
								Caption: ko.observable(""),
								ToolTip: ko.observable("Settings"),
								Visible: ko.observable(true),
								Enabled: ko.observable(true),
								TargetUrl: ko.observable(""),
								MethodInfo: ko.observable("fal fa-cog"),
								click: () => {
									this.OpenSettingsTab(vm.SettingsUrl());
								},
								ButtonType: ko.observable("Button"),
								Items: ko.observable(null)
							};
							if (this.Context() != null && this.Context().Container() != null && this.Context().Container().length > 0
								&& this.Context().Container()[0].Buttons != null) {
								this.Context().Container()[0].Buttons.push(statusButton);
							} else if (this.ToolbarButtons() != null) {
								(this.ToolbarButtons().push(statusButton));
							}
						}
						return true;
					}
				}
			}
			return false;
		});
		this.TitleComputed = ko.pureComputed(() => {
			const tabAdded = this.TabAdded();
			// setTimeout(() => {
			// 	if (this.TabViewModel() != null) {
			// 		this.TabViewModel().CalculateHeight();
			// 	}
			// 	if (this.$TabController != null) {
			// 		this.$TabController.CalculateHeight();
			// 	}
			// }, 10);
			if (this.IsDirty() && this.EnableDirtyTracking()) {
				return this.Title() + " *";
			} else {
				return this.Title();
			}
		});
		this.subscriptions.push(this.Context.subscribe(() => {
			if (this.Context() != null) {
				const BaoMenu = window.baorequire("Services/baoMenu");
				BaoMenu.addContext(this.Context());
				if (this.IsActiveTab()) {
					BaoMenu.selectContext(this.Context());
				}
			}
		}));
		this.subscriptions.push(this.TitleComputed.subscribe((newTitle) => {
			if (this.IsActiveTab() && this.TabViewModel() != null && this.TabViewModel().GlobalMode == true) {
				document.title = Bao.Session.ApplicationName() + " - " + newTitle;
			}
		}));
		this.subscriptions.push(this.ObjectId.subscribe(() => {
			if (this.ObjectId != null && this.ObjectId() != null && this.Route != null && this.Route.details != null) {
				let newRequest = "";
				if (this.Route.details.replaceRoute != null) {
					newRequest = this.Route.details.replaceRoute.replace("{id}", this.ObjectId());
				} else if (this.Route.data.params.length <= 1 && this.Route.data.route._pattern.indexOf("{id}") > -1) {
					newRequest = this.Route.data.route._pattern.replace("{id}", this.ObjectId());
				}
				const baoRouter = window.baorequire("Services/baoRouter");
				newRequest = baoRouter.fillParams(this, newRequest);
				if (newRequest != "") {
					if (this.IsActiveTab() && this.$TabController != null && this.$TabController.GlobalMode) {
						const hasher = window.baorequire("hasher");
						hasher.replaceHash(newRequest);
					}
					this.Route.request = newRequest;
				}
			}
		}));
		this.subscriptions.push(this.DirtyFlag.subscribe((value) => {
			this.IsDirty(value);
		}));
	}
	public destroy = () => {
		this.IsLoading(false);
		delete Bao.Templates[this.TemplateName()];
		this.TitleComputed.dispose();
		this.StatusIconComputed.dispose();
		this.SettingsIconComputed.dispose();
		this.LoadContent.dispose();
		ko.utils.arrayForEach(this.subscriptions, function (s) {
			s.dispose();
		});
		this.subscriptions = null;
		this.ClearMenuEvents();
	}
	public ClearMenuEvents = () => {
		const def = $.Deferred();
		for (let i = 0; i < this.MenuEvents.length; i++) {
			this.Menu.unregisterEvent(this.MenuEvents[i]);
			delete this.MenuEvents[i];
		}
		this.MenuEvents = [];
		def.resolve();
		return def.promise();
	}
	public OpenStatusDialog = () => {
		return Bao.get("BaoDialog/Status", (view) => {
			const BaoDialogViewModel = window.baorequire("Factories/baoDialog");
			const statusDialog = new BaoDialogViewModel(ko.unwrap(this.ViewModel().TabName));
			statusDialog.Width(600);
			statusDialog.Template(view);
			statusDialog.ViewModel({
				InsertDate: ko.observable(ko.unwrap(this.ViewModel().InsertDateHtml)),
				InsertBy: ko.observable(ko.unwrap(this.ViewModel().InsertBy)),
				UpdateDate: ko.observable(ko.unwrap(this.ViewModel().UpdateDateHtml)),
				UpdateBy: ko.observable(ko.unwrap(this.ViewModel().UpdateBy))
			});
			statusDialog.Open();
		});
	}
	public OpenSettingsTab = (url: string) => {
		if (url) {
			baoRouter.setHash(url);
        }
	}
	public ContentLoadedDefault = (result, js) => {
		if (result[0].Title != null) {
			this.Title(result[0].Title);
		}
		if (result[0].ToolTip != null) {
			this.ToolTip(result[0].ToolTip);
		}
		if (this.ViewModel() != null) {
			if (result[0].Model != null) {
				ko.map.fromJS(result[0].Model, this.ViewModel(), this.DirtyFlag);
			}
		}
		Bao.Templates[this.Id()] = result[0].Message;
		this.TemplateName(this.Id());
		if (result[0].Context != null) {
			const koContext = ko.map.fromJS(result[0].Context);
			this.Context(koContext);
		}
		this.IsLoading(false);
		this.TabLoaded();
		this.Loaded(true);
	}
	public loadJavaScript = () => {
		const def = $.Deferred();
		if (this.JavaScript() != null) {
			let jsVersion = 1;
			if (Bao != null && Bao.Session != null && Bao.Session["JsVersion"] != null) {
				jsVersion = Bao.Session["JsVersion"];
			}
		} else {
			def.resolve();
		}
		return def;
	}
	public loadContent() {
		return Bao.post(this.Url(), JSON.stringify(this.UrlData()));
	}
	public TabLoaded() { }
	public TabSelected() { }
	public TabUnselected() { }
}
export default TabPage;
